module.exports = __webpack_public_path__ + "img/have_look_001.2d0e0643.png";